import StatsCard from "../../../../components/stats-card";
import styles from "../css/expiredStock.module.css";

export default function ExpiredStockStats() {
  return (
    <div className={styles.statsRow}>
      <StatsCard
        title="Items expiring in the next 3 months"
        value={10}
        icon="hourglass"
        titleSize="1.25rem"
        valueSize="1.75rem"
        style={{
          "--stats-title-color": "#eab308", // yellow-500
          "--stats-value-color": "#eab308",
          "--stats-icon-color": "#eab308",
          "--stats-icon-bg": "rgba(234, 179, 8, 0.12)",
        }}
      >
        <div className={styles.cardSubtext}>Products below their reorder level.</div>
      </StatsCard>
      <StatsCard title="Total Wastage Value" value={"R4589.50"} icon="r" titleSize="1.25rem" valueSize="1.75rem">
        <div className={styles.cardSubtext}>Total cost of all items that have expired.</div>
      </StatsCard>
      <StatsCard
        title="Total Items Expired"
        value={7}
        icon="boxes"
        titleSize="1.25rem"
        valueSize="1.75rem"
        style={{
          "--stats-title-color": "#ef4444", // red-500
          "--stats-value-color": "#ef4444",
          "--stats-icon-color": "#ef4444",
          "--stats-icon-bg": "rgba(239, 68, 68, 0.12)",
        }}
      >
        <div className={styles.cardSubtext}>Reorder Products</div>
      </StatsCard>
    </div>
  );
}
